// src/redux/actions/likesActions.js

export const setDislikesSent = (dislikes) => ({
  type: "SET_DISLIKES_SENT",
  payload: dislikes,
});


export const addDislikeSent = (dislike) => ({
  type: "ADD_DISLIKE_SENT",
  payload: dislike,
});

export const sendDislike = (idProjet,idPresta, token) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("idProjet", idProjet);
      formData.append("idPresta", idPresta);

      const response = await fetch(apiUrl+"/api/dislikes", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erreur lors de l’envoi du like");
      }

      if (data.status === "dislike") {
        dispatch({ type: "ADD_DISLIKE_SENT", payload: data.dislike || { idProjet } });
      }
      return data;
    } catch (error) {
      console.error("Erreur envoi dislike:", error);
      throw error;
    }
  };
};
